import axios from 'axios';
import { getUpgradeVariant } from './upgradeExperiment';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = 'lumera_session_id';

const getSessionId = () => {
  try {
    let sid = localStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = (crypto?.randomUUID?.() || String(Date.now() + Math.random()));
      localStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch { return null; }
};

/** Fire-and-forget premium-paywall funnel event (shown | clicked | dismissed). */
export const logPaywall = (event, feature, audience) => {
  try {
    axios.post(`${BACKEND_URL}/api/analytics/paywall`, {
      event,
      feature: feature || 'unknown',
      audience: audience || 'unknown',
      session_id: getSessionId(),
      variant: getUpgradeVariant(),
    }).catch(() => {});
  } catch { /* ignore */ }
};
